const aboutAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP */
      let mm = gsap.matchMedia();

      //H1 BANNER
      let split = SplitText.create(".header h1", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
      });


      //TEAM MEMBER

      gsap.from('.member', {
        //x: -100,
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".team",
          start: "top 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      //CLIENT SECTION
      split = SplitText.create(".clients h2", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".clients",
          start: "top+=100 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

       mm.add("(min-width: 900px)", () => {
      gsap.from('.client-1', {
        x: -100,
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".client-1",
          start: "60% 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });

      gsap.from('.client-2', {
        x: 100,
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".client-2",
          start: "60% 80%",
          end: "bottom top",
          scrub: false,
          markers: false,
          toggleActions: "play none none reverse",
        },
      });
      });
    });
  },
};

export default aboutAnim;
